import type { McpOAuthGrantListResponse, McpOAuthGrantRevokeResponse } from '../types/api'
import { apiClient } from './client'

export async function listOAuthGrants(orgId?: number): Promise<McpOAuthGrantListResponse> {
  const params = orgId != null ? `?orgId=${orgId}` : ''
  return apiClient.get<McpOAuthGrantListResponse>(`/mcp/oauth/grants${params}`)
}

export async function revokeOAuthGrant(id: number): Promise<McpOAuthGrantRevokeResponse> {
  return apiClient.delete<McpOAuthGrantRevokeResponse>(`/mcp/oauth/grants/${id}`)
}

export interface OAuthRedirectResponse {
  redirect_to: string
}

export interface OAuthConsentRequestResponse {
  subject: string
  client_id: string
  requested_scope: string[]
  requested_audience: string[]
}

/** Accept a Hydra login challenge for the current JWT session user. */
export async function acceptOAuthLogin(loginChallenge: string): Promise<OAuthRedirectResponse> {
  return apiClient.post<OAuthRedirectResponse>('/oauth2/login/accept', {
    login_challenge: loginChallenge,
  })
}

/** Read the scopes/audience/client behind a consent challenge for confirmation UI. */
export async function getOAuthConsentRequest(
  consentChallenge: string
): Promise<OAuthConsentRequestResponse> {
  return apiClient.get<OAuthConsentRequestResponse>(
    `/oauth2/consent/request?consent_challenge=${encodeURIComponent(consentChallenge)}`
  )
}

/** Grant audience-bound scope, mirror the grant locally, return the Hydra redirect. */
export async function acceptOAuthConsent(consentChallenge: string): Promise<OAuthRedirectResponse> {
  return apiClient.post<OAuthRedirectResponse>('/oauth2/consent/accept', {
    consent_challenge: consentChallenge,
  })
}

/** Deny consent — explicit OAuth error, never a token, no local row. */
export async function rejectOAuthConsent(consentChallenge: string): Promise<OAuthRedirectResponse> {
  return apiClient.post<OAuthRedirectResponse>('/oauth2/consent/reject', {
    consent_challenge: consentChallenge,
  })
}
